import { ChevronLeft, Reply } from "@mui/icons-material";
import moment from "moment";
import React from "react";
import { authGetRequest } from "../../../../../../api/laravel/public/api";
import ReplyComponent from "./reply";

function Comment(props) {
  const { item } = props;

  const replyClick = async (ev) => {
    const { data_r, isError, isLoading } = await authGetRequest(
      "/account/dashboard/discussions/view/" + ev
    );
  };

  const showReply = (ev,count) => {
    if (
      document.getElementById("replyContainer" + ev).style.display === "none"
    ) {
      document.getElementById("replyContainer" + ev).style.display = "block";
      document.getElementById("btnShowReply" + ev).innerText="Hide All Replies ("+count+")";
    } else {
      document.getElementById("replyContainer" + ev).style.display = "none";
      document.getElementById("btnShowReply" + ev).innerText="Show All Replies ("+count+")";
    }
  };

  return (
    <div className="p-2 m-1 ml-3">
      <div className="d-flex mb-0 flex-row align-items-center justify-content-between">
        <div className="d-flex flex-row align-items-center w-100">
          <img
            className="img-fluid-xsm img-thumbnail rounded"
            width={50}
            src={
              process.env.LOCAL_FILE_PATH +
              "profile/medium/" +
              item?.created_by?.image
            }
          />
          <div className="d-flex flex-column align-items-start m-3">
            <span className="text-muted">
              <p className="h6 w-100">
                {item?.created_by?.first_name +
                  " " +
                  item?.created_by?.last_name}
              </p>
            </span>
            <small className="h6">{moment(item?.created_at).fromNow()}</small>
          </div>
        </div>
        <a
          href="{{ url('') }}/admin/course/delete-comment/${value['id']}"
          onclick="return confirm('Are you sure you want to delete this item?');"
        >
          <i className="bx bx-trash" />
        </a>
      </div>
      <div className="d-flex mb-1 flex-column align-items-start justify-content-between">
        <dd
          className="h6"
          dangerouslySetInnerHTML={{ __html: item?.description }}
        ></dd>
      </div>
      <div className="d-flex mb-1 flex-row align-items-start justify-content-between">
        <div className="d-flex flex-row "></div>
        <div className="d-flex flex-row ">
          <button
            onClick={() => showReply(item.id,item?.comments_more.length-1)}
            className="btn btn-sm btn-primary mx-2 h6"
          >
            <ChevronLeft />
           <b id={"btnShowReply"+item.id}>Show All Replies ({item?.comments_more.length-1})</b> 
          </button>
          <button className="btn btn-sm btn-dark mx-2 h6">
            <Reply />
            Reply
          </button>
        </div>
      </div>
      <div className="mx-4">
        {item?.comments_more?.map((it, ind) => (
          <ReplyComponent key={ind} item={it} index={item.id} />
        ))}
      </div>
    </div>
  );
}

export default Comment;
